// pages/public/NotFoundPage.jsx
import { Link } from 'react-router-dom';
import PublicLayout from '../../layout/PublicLayout';
import { Home, ArrowLeft, UtensilsCrossed } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <PublicLayout>
      <div className="min-h-[70vh] flex items-center justify-center px-4 py-16 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-md w-full text-center">
          <div className="relative inline-block mb-6">
            <div className="w-24 h-24 sm:w-28 sm:h-28 mx-auto rounded-full bg-red-100 flex items-center justify-center text-red-600 shadow-inner">
              <UtensilsCrossed className="w-12 h-12 sm:w-14 sm:h-14 stroke-[1.5]" />
            </div>
            <span className="absolute -bottom-2 right-2 bg-yellow-400 text-red-800 text-xs font-bold px-2.5 py-1 rounded-full shadow">
              404
            </span>
          </div>

          <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-3 tracking-tight">
            Plato no encontrado
          </h1>
          <p className="text-gray-600 mb-8 leading-relaxed">
            Parece que la página o sección que buscas no existe o ha sido movida. ¡No te quedes con hambre y vuelve a nuestro menú principal!
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-red-600 hover:bg-red-700 text-white font-semibold transition-all shadow-md hover:shadow-lg"
            >
              <Home className="w-4 h-4" />
              Ir al Inicio
            </Link>
            <button
              onClick={() => window.history.back()}
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Regresar
            </button>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default NotFoundPage;
